import React from 'react';

import { toast } from 'react-toastify';

import { API_DOMAIN } from '../const';
import copyToClipboard from '../tools/copyToClipboard';
import '../css/file-upload.css';

export default function FileUpload({ onLoad, directory }) {
    function uploadFile(event) {
        const file = event.currentTarget.files[0];
        const formData = new FormData();

        formData.append('file', file);
        formData.append('dir', directory || 'files');

        const req_params = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                enctype: 'multipart/form-data',
            },
            body: formData,

        };

        fetch(`${API_DOMAIN}storage/files/`, req_params)
            .then((response) => {
                if (!response.ok) {
                    toast.error('Что-то пошло не так');
                    throw response.json();
                }

                if (response.status === 204) {
                    toast.error('Что-то пошло не так');

                    return '';
                }

                return response.json();
            })
            .then((data) => {
                copyToClipboard(data.url);
                onLoad(data);

                toast.success('Файл загружен и скопирован в буфер обмена');
            });
    }

    return (
        <form className="file-upload">
            <label className="file-upload__wrap" htmlFor="file">
                <input className="file-upload__input" id="file" type="file" onChange={uploadFile} />
                <span className="file-upload__button">Загрузить файл</span>
            </label>
        </form>
    );
}
